/*** Libraries */
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";

/***  Constant, Services  */
import { SiteData, UserConstants, UserData, UserFormProps } from './user.types';
import { createUser, addUserTemp } from './userSlice';
import type { AppDispatch, RootState } from '../../store/store';
import CustomMultiSelect from "../../components/Custom-Multiselect/CustomMultiSelect";
import { useLoader } from '../../context/LoaderContext';

/** Styles */
import './user.style.css';

const UserForm: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const siteMetaData = useSelector((state: RootState) => state.users.sites);
    const { setLoading } = useLoader();
    const [form, setForm] = useState<Omit<UserData, 'id'>>({
        firstName: '',
        lastName: '',
        email: '',
        siteName: [],
        status: '',
        preferredLanguage: ''
    });

    type UserFormErrors = {
        [K in keyof UserData]?: string;
    };

    const [errors, setErrors] = useState<UserFormErrors>({});
    const [selectedSiteNames, setSelectedSiteName] = useState<string[]>([]);
    const loginUserData = useSelector((state: RootState) => state.users.loginUser);

    useEffect(() => {
      
    }, []);

    /**
     * Validate form fields
     * @param data 
     * @returns 
     */
    const validateUserFields = (data: UserData): UserFormErrors => {
        try {
            const errs: UserFormErrors = {};
            if (!data.firstName.trim()) {
                errs.firstName = UserConstants.ERROR_FIRSTNAME_REQUIRED;
            }
            if (!data.lastName.trim()) {
                errs.lastName = UserConstants.ERROR_LASTNAME_REQUIRED;
            }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
                errs.email = UserConstants.ERROR_EMAIL_REQUIRED;
            }
            return errs;
        } catch (exe) {
            console.log(exe);
            return {}
        }
    };

    /**
     * On change
     * @param e 
     */
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            setForm({ ...form, [e.target.name]: e.target.value });
            setErrors(prev => ({ ...prev, [e.target.name]: undefined }));
        } catch (exe) {
            console.log(exe);
        }
    };

    /**
     * On submit
     * @param e 
     * @returns 
     */
    const handleSubmit = async(e: React.FormEvent) => {
        try {
            e.preventDefault();
            const newUser: UserData = { ...form, id: form.firstName };
            const validationErrors = validateUserFields(newUser);

            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }
            setLoading(true);
            newUser.status = "Inactive";
            newUser.siteName = selectedSiteNames;
            const result = await dispatch(createUser({user : newUser, loginUserData})).unwrap();
            setLoading(false);
            if(result){
                toast.success(UserConstants.USER_ADDED);
                setForm({ firstName: '', lastName: '', email: '', siteName: [], status: '', preferredLanguage:'' });
                setSelectedSiteName([]);
            }else{
                toast.error(UserConstants.ERROR_ADD_USER);
            }
        } catch (error: any) {
            setLoading(false);
            let errorMessage = UserConstants.ERROR_ADD_USER;
            if(typeof error === "string"){
               errorMessage = error
            }
            toast.error(errorMessage);
        }
    };

    /**
     * Selected multiselect items
     * @param selectedItems 
     */
    const onSiteSelectionChange = (selectedItems: string[]) => {
        setSelectedSiteName(selectedItems);
    }

    return (
        <>
            {/* Create New User */}
            <div className="bg-white p-4 rounded shadow-sm mb-4">
                <h6 className="mb-4 fs-18">Create a new user</h6>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Control
                                name="firstName"
                                placeholder="First Name"
                                value={form.firstName}
                                onChange={handleChange}
                                isInvalid={!!errors.firstName}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.firstName}
                            </Form.Control.Feedback>
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                name="lastName"
                                placeholder="Last Name"
                                value={form.lastName}
                                onChange={handleChange}
                                isInvalid={!!errors.lastName}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.lastName}
                            </Form.Control.Feedback>
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                name="email"
                                placeholder="Email"
                                value={form.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Col>
                        <Col md={3}>
                            {/*<Form.Control
                                name="siteName"
                                placeholder="Site Name"
                                value={form.siteName}
                                onChange={handleChange}
                            /> */ }
                            <CustomMultiSelect
                                options={siteMetaData}
                                selected={selectedSiteNames}
                                onChange={onSiteSelectionChange}
                                placeholder="Select site"
                                disabled={false}
                            />
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-end">
                        <Col md="auto">
                            <button className="d-flex align-items-center btn btn-primary btn-create-user rounded-pill">Create new user</button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
};

export default UserForm;